import { LuBuilding2, LuCalendar, LuMessagesSquare, LuFingerprint, LuInfo, LuLayoutDashboard, LuListChecks, LuPaperclip, LuUser, LuUser2, LuStickyNote } from "react-icons/lu";
import { APP_URLS } from "../../config";
import { COMMON_MENU } from "./common/common";
import { FaFileInvoice } from "react-icons/fa";
import { GrDocumentDownload } from "react-icons/gr";


export const HR_MENU = [
    ...COMMON_MENU,
    {
        title: 'Users',
        icon: LuFingerprint,
        hasSubMenu: true,
        submenu: [
            {
                title: 'Employees',
                icon: LuUser2,
                path: APP_URLS.EMPLOYEES.ROUTE,
            },
            {
                title: 'Users List',
                path: APP_URLS.USERS.ROUTE,
                icon: LuFingerprint,
            },
            {
                title: 'Attendance',
                path: APP_URLS.ATTENDANCE.LIST,
                icon: LuListChecks
            },
            {
                title: 'Leaves',
                path: APP_URLS.LEAVES.ALL,
                icon: LuPaperclip
            },
            {
                title: 'Payslips',
                path: APP_URLS.PAYSLIP.ROUTE,
                icon: FaFileInvoice
            },
            {
                title: 'Conversations',
                path: APP_URLS.CONVERSATION.ALL,
                icon: LuMessagesSquare
            },
            {
                title: 'Reports',
                icon: GrDocumentDownload,
                path: APP_URLS.REPORT,
                hasSubMenu: false
            },
        ]
    },
    {
        title: 'Organization',
        icon: LuBuilding2,
        hasSubMenu: true,
        submenu: [
            {
                title: "Settings",
                path: APP_URLS.ORGANIZATION.SETTINGS,
                icon: LuInfo
            }
        ]
    }
]